import { call, put, takeLatest } from 'redux-saga/effects';
import {
  fetchBookmarksRequest,
  fetchBookmarksSuccess,
  fetchBookmarksFailure,
} from '../slice/getBookmarkSlice';
import { fetchBookmarksApi } from '@src/api/apiService';
import { getApiError } from "@src/utils/apiError";

export function* fetchBookmarks(
  action: ReturnType<typeof fetchBookmarksRequest>
): Generator<any, void, any> {
  try {
    const { offset, limit, search } = action.payload;

    const response = yield call(
      fetchBookmarksApi,
      offset,
      limit,
      search
    );

    yield put(
      fetchBookmarksSuccess({
        ...response.data,
        offset,
      })
    );
  } catch (error: unknown) {
    const apiError = getApiError(error);
    yield put(
        fetchBookmarksFailure(
            apiError.message
        )
    );
  }
}

export function* getBookmarkSaga() {
  yield takeLatest(fetchBookmarksRequest.type, fetchBookmarks);
}
